import { css } from '@emotion/react';

import { AccordionSizeType } from './Accordion';

export const paddingSize = {
  large: 16,
  medium: 12,
};

export const container = css`
  position: relative;
`;

export const titleWrapper = (size: AccordionSizeType) => css`
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: ${paddingSize[size]}px;
  cursor: pointer;
  background-color: transparent;
  transition: all 0.15s cubic-bezier(0.4, 0, 0.2, 1);

  @media (hover: hover) and (pointer: fine) {
    :hover {
      background-color: var(--gray-60);
    }
  }

  &::after {
    content: '';
    display: block;
    position: absolute;
    width: calc(100% - ${paddingSize[size] * 2}px);
    height: 0px;
    border-bottom: solid 0.5px var(--gray-200);
    bottom: 0;
    left: ${paddingSize[size]}px;
  }
`;

export const noBorder = css`
  &::after {
    display: none;
  }
`;

export const titleIconWrapper = css`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-right: 16px;
`;

export const titleIcon = css`
  margin-right: 10px;
`;

export const title = css`
  font-size: 16px;
  font-weight: 600;
  letter-spacing: -0.32px;
  color: var(--gray-800);
  display: -webkit-box;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
`;

export const expandIcon = css`
  transform: rotate(0);
  transition: transform 0.25s cubic-bezier(0.4, 0, 0.2, 1);
`;

export const rotateIcon = css`
  transform: rotate(180deg);
`;

export const content = (size: AccordionSizeType) => css`
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 0px;
  font-size: 15px;
  line-height: 1.6;
  letter-spacing: -0.5px;
  color: var(--gray-800);
  padding: 0 ${paddingSize[size]}px;
  overflow: hidden;
  transition: height 0.25s cubic-bezier(0.4, 0, 0.2, 1);
`;

export const showContent = (height: number) => css`
  height: ${height + 32}px;
`;

export const hiddenContent = (size: AccordionSizeType) => css`
  font-size: 15px;
  line-height: 1.6;
  letter-spacing: -0.5px;
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
  z-index: -1;
  padding: 0 ${paddingSize[size]}px;
`;
